import
{
    FC
} from "react";

import TypeAhead from "../TypeAhead/TypeAheadString";

import
{
    User,
    PaginatedResult,
    UserDetails,
    PriceList
} from "@ews/react-data";

import
{
    useUser,
    useTypeAheadUserList,
    getUserDisplayName
} from "../ReactData/user";
import { TypeaheadProps } from "../TypeAhead/types";
import { globalDebounceTime } from "../../setup/locale";
import { useActivePriceList, usePriceList, useTypeAheadPriceList } from "../ReactData/misc";
import { LabelValue } from "../Settings/type";

type LabelledUser = User & {
    label: string;
};

const PriceListTypeAhead: FC<{
    label?: LabelValue["text"];
    priceListId: string,
    onChange: (id: string) => void;
}> = ({
    label = "COM_FACPMANAGEMENT_FACP_MANAGER_PRICES",
    priceListId,
    onChange
}) =>
    {

        const typeAhead = useTypeAheadPriceList();
        const priceList = useActivePriceList(priceListId);

        if (!priceList) return <></>;

        return <TypeAhead
            id="price-list-type-ahead"
            text={label}
            debounce={globalDebounceTime}
            value={priceList.priceList}

            onFilter={async (priceList) => new Promise<TypeaheadProps["list"]>(async resolve =>
            {

                const search = await typeAhead({ pageSize: 10, priceList, sortCriteria: "priceList" }) as PaginatedResult<PriceList>;

                resolve(search
                    .results
                    .map((data: PriceList) =>
                    {
                        return { key: "priceList", data };
                    })
                );
            })}
            onChange={(data) =>
            {
                const id = (data as PriceList).id;
                if (id) onChange(id);
            }}
        />;

    };

export default PriceListTypeAhead;